import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import('@/pages/index/index.vue'),
  },
  {
    path: "/doctors",
    component: () => import('@/pages/doctors.vue'),
  },
  {
    path: "/form-download",
    component: () => import('@/pages/form-download.vue'),
  },
  {
    path: "/service-detail",
    component: () => import('@/pages/service-detail.vue'),
  },
  {
    path: "/anaesthesia-for-children",
    component: () => import('@/pages/anaesthesia-for-children.vue'),
  },
  {
    path: "/anaesthesia-for-elderly-patients",
    component: () => import('@/pages/anaesthesia-for-elderly-patients.vue'),
  },
  {
    path: "/caudal-anaesthesia",
    component: () => import('@/pages/caudal-anaesthesia.vue'),
  },
  {
    path: "/spinal-and-epidural-anaesthesia",
    component: () => import('@/pages/spinal-and-epidural-anaesthesia.vue'),
  },
  {
    path: "/understanding-general-anaesthesia",
    component: () => import('@/pages/understanding-general-anaesthesia.vue'),
  },
  {
    path: "/procedural-sedation-and-analgesia",
    component: () => import('@/pages/procedural-sedation-and-analgesia.vue'),
  },
  {
    path: "/nerve-blocks",
    component: () => import('@/pages/nerve-blocks'),
  },
  {
    path: "/billing",
    component: () => import('@/pages/billing.vue'),
  },
  {
    path:"/comingsoon",
    component:() => import('@/pages/special/comingsoon')
  },
  {
    path:"/maintenance",
    component:() => import('@/pages/special/maintenance')
  },
  {
    path:"/error",
    component:() => import('@/pages/special/error')
  },
  {
    path:"/contactus",
    component:() => import('@/pages/contactus.vue')
  },
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;